import { Component, OnInit, Input } from "@angular/core";
import {
  AlertController,
  ModalController,
  NavController,
} from "@ionic/angular";
import { Network } from "@capacitor/network";
import { UtilService } from "../../services/util.service";
import { ActivatedRoute } from "@angular/router";
import { OfflineApiService } from "src/app/services/offline-api.service";
import { SharedDataService } from "src/app/services/shared-data.service";
import { OfflineManagerService } from "src/app/services/offline-manager.service";
import { EnumService } from "src/app/services/enum.service";
import { ObservablesService } from "src/app/services/observables.service";
import { DeviceDetailData } from "src/app/_models/offline/DeviceDetailData";

@Component({
  selector: "app-device-offline",
  templateUrl: "./device-offline.page.html",
  styleUrls: ["./device-offline.page.scss"],
})
export class DeviceOfflinePage implements OnInit {
  UtilService = UtilService;
  isDeviceHaveOfflineData = false;
  lastSyncDate;
  isWebApp = UtilService.isWebApp();
  @Input() isIncompleteSync = false;
  @Input() incompleteSyncMessage = '';
  @Input() isOfflineNotEnabled = false;
  constructor(
    public navController: NavController,
    public modalController: ModalController,
    public alertController: AlertController,
    public activatedRoute: ActivatedRoute,
    public utilService: UtilService,
    public offlineApiService: OfflineApiService,
    public offlineManagerService: OfflineManagerService,
    public observablesService: ObservablesService,
    public sharedDataService: SharedDataService
  ) {}

  ngOnInit() {
    console.log("Modal Test");
    
    // Log incomplete sync info if provided via componentProps
    if (this.isIncompleteSync) {
      console.log('⚠️ [MODAL] Incomplete sync detected. Message:', this.incompleteSyncMessage);
    }
    
    const syncDate = localStorage.getItem(
      EnumService.LocalStorageKeys.SYNC_DATE_TIME
    );
    this.lastSyncDate = syncDate;
    if (this.lastSyncDate) {
      this.isDeviceHaveOfflineData = true;
    } else {
      this.isDeviceHaveOfflineData = false;
    }
  }

  async loadDataset() {
    const { connected } = await Network.getStatus();
    const isOffline = !connected;

    this.sharedDataService.offlineMode = isOffline;
    this.offlineManagerService
      .getDeviceDetail()
      .then((deviceDetail: DeviceDetailData) => {
        this.offlineManagerService.offlineDeviceDetailData = deviceDetail;
      })
      .catch((error) => {});

    localStorage.setItem(
      EnumService.LocalStorageKeys.OFFLINE_MODE_ENABLE,
      "true"
    );
    localStorage.removeItem('background_sync_state');
    this.observablesService.publishSomeData(
      EnumService.ObserverKeys.OFFLINE_MODE_CHANGE,
      isOffline
    );
    this.modalController.dismiss();

    this.navController.navigateRoot("dashboard-dm", { replaceUrl: true });
  }

  closeApp() {
    try {
      navigator["app"].exitApp();
    } catch (error) {}
  }
}
